import { Button, Form, Input, Popover } from "antd";
import { FormProvider } from "../../../../../common/provider/form/Form.provider";
import style from "./style.module.scss";
import { SimpleInput } from "../../../../../common/components/simpleInput";
import React, { lazy, Suspense, useContext, useEffect, useState } from "react";
import { OperationContext } from "../CreateOperation";
import { CustomTabs } from "../../../../../common/components/Tabs/CustomTabs";
import { capitalizeFirstLetter } from "../../../../../utilities/string";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { useSearchParams } from "react-router";
import { OperationConstant } from "../../../core/_constant";
import { IoIosAddCircleOutline } from "react-icons/io";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { FormProps } from "../../../store/ManifestoStore";
import { ManifestoService } from "../../../core/_request";
import { API_URLs } from "../../../../../utilities/API_URLs";
import { useOperationType } from "../../../core/_context";

export const LandingForm = () => {
  const [form] = Form.useForm();

  const { initialValue } = useContext(OperationContext);
  const [searchParams] = useSearchParams();

  const operationType = useOperationType();

  const [openTooltip, setOpenTooltip] = useState<boolean>(false);
  const [mouvementTypes, setMouvementTypes] = useState<any[]>([]);

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [shouldRefreshTabs, setShouldRefreshTabs] = useState(false);

  const [tabItems, setTabItems] = useState<Array<any>>([]);
  const [activeTabID, setActiveTabID] = useState<string>(
    initialValue?.debarkationMovement?.loadPossessionStatus?.[0]?.id
  );

  const DynamicComponent = (name: string) => {
    try {
      return React.lazy(() => import(`./Landing${name}List.tsx`));
    } catch (error) {
      console.error("Error loading component", error);
      return null;
    }
  };

  const DynamicFormComponent = (
    name: string
  ): React.LazyExoticComponent<React.ComponentType<FormProps>> => {
    return lazy(
      () => import(`./components/${capitalizeFirstLetter(name)}Form.tsx`)
    );
  };

  const [LoadedFormComponent, setLoadedFormComponent] =
    useState<React.LazyExoticComponent<React.ComponentType<FormProps>> | null>(
      null
    );

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const response = await ManifestoService.getAllMouvement(
          API_URLs.operations.salesOperations.manifesto.loadTypeSelect
        );
  
        setMouvementTypes(response?.data?.member || []);
      } catch (error) {
        console.error("Erreur récupération load types", error);
      }
    };
    
    fetchTypes();
  }, [shouldRefreshTabs]);

  useEffect(() => {
    if (activeTabID) {
      const loadComponent = DynamicFormComponent(activeTabID);
      setLoadedFormComponent(loadComponent);
    }
  }, [activeTabID]);

  useEffect(() => {
    initialValue?.debarkationMovement &&
      form.setFieldsValue({
        customerShipowner:
          initialValue?.debarkationMovement?.customerShipowner?.name,
        movementCount: initialValue?.debarkationMovement?.movementCount,
        additiveCount: initialValue?.debarkationMovement?.additiveCount,
        notDebarkedCount: initialValue?.debarkationMovement?.notDebarkedCount,
        filledCount: initialValue?.debarkationMovement?.filledCount,
        emptyCount: initialValue?.debarkationMovement?.emptyCount,
        totalBagTonnage: initialValue?.debarkationMovement?.totalBagTonnage,
        remainingContainerCount: initialValue?.debarkationMovement?.remainingContainerCount,
        remainingCount: initialValue?.debarkationMovement?.remainingCount,
        remainingBagTonnage: initialValue?.debarkationMovement?.remainingBagTonnage,
      });

    setTabItems(
      initialValue?.debarkationMovement?.loadPossessionStatus?.map(
        (item: any) => {
          const Component = DynamicComponent(capitalizeFirstLetter(item?.id));
          return {
            ...item,
            key: item?.id,
            label: item?.name,
            children: (
              <Suspense fallback={<Loader isLoading />}>
                {Component && <Component />}
              </Suspense>
            ),
          };
        }
      )
    );
    setShouldRefreshTabs(false);
  }, [initialValue, shouldRefreshTabs]);

  useEffect(() => {
    if (tabItems?.length) {
      setActiveTabID(tabItems?.[0]?.id);
    }
  }, [tabItems]);

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);
    const findID = newParams.get("mouvement")?.toUpperCase();
    findID && setActiveTabID(findID as string);
  }, [searchParams]);

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onFinishAction = () => {
    onShowAddHandler();
    setShouldRefreshTabs(true);
  };

  const SelectType = () => {
    return (
      <div className="px-2 max-h-60 select_container">
        {mouvementTypes.map((type: any, index: number) => (
          <React.Fragment key={type.id}>
            <div
              className={style.select_item}
              onClick={() => handleSelectType(type.id)}
            >
              <span className={style.text_name}>{type.name}</span>
            </div>

            {index !== mouvementTypes.length - 1 && (
              <div className={style.separator} />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };
  
  
  const handleSelectType = (typeId: string) => {
    setActiveTabID(typeId);
    setLoadedFormComponent(DynamicFormComponent(typeId));
    setOpenTooltip(false);
    setIsShowForm(true);
  };
  
  return (
    <>
      <div className={style.landing}>
        <FormProvider
          Form={Form}
          form={form}
          onFinish={(values: any) => {
            console.log(values);
          }}
          onFinishFailed={(err) => {
            console.log("err", err);
          }}
        >
          <div className={style.landing__form}>
          { operationType === "sales" && (
            <div className={style.landing__form_content}>
              <div className={style.landing__form_item}>
                <SimpleInput
                  Form={Form}
                  name={"customerShipowner"}
                  label="Armateur"
                  customInput={<Input disabled />}
                />
              </div>
              <div className={style.landing__form_item}></div>
              <div className={style.landing__form_item}></div>
            </div>
)}
            <div className={style.landing__form_content}>
              <div className={style.landing__form_item}>
                <SimpleInput
                  Form={Form}
                  name={"movementCount"}
                  label="Total de mouvements prévus"
                  customInput={
                    <Input disabled className={style.landing__input_number} />
                  }
                />
              </div>
              <div className={style.boarding__form_item}>
                <SimpleInput
                  Form={Form}
                  name={"remainingCount"}
                  label="Total de mouvements restants"
                  customInput={
                    <Input disabled className={style.landing__input_number} />
                  }
                />
              </div>
              <div className={style.landing__form_item}></div>
            </div>
            <div className={style.landing__form_content}>
              <div className={style.landing__form_item}>
                <SimpleInput
                  Form={Form}
                  name={"additiveCount"}
                  label="Additif"
                  customInput={
                    <Input disabled className={style.landing__input_number} />
                  }
                />
              </div>
              <div className={style.landing__form_item}>
                <SimpleInput
                  Form={Form}
                  name={"notDebarkedCount"}
                  label="Total non debarqué"
                  customInput={
                    <Input disabled className={style.landing__input_number} />
                  }
                />
              </div>
              <div className={style.landing__form_item}></div>
            </div>
            <div className={style.landing__form_content}>
              {activeTabID === OperationConstant.CONTAINER_ID && (
                <>
                  <div className={style.landing__form_item}>
                    <SimpleInput
                      Form={Form}
                      name={"filledCount"}
                      label="Pleins"
                      customInput={
                        <Input
                          disabled
                          className={style.landing__input_number}
                        />
                      }
                    />
                  </div>
                  <div className={style.landing__form_item}>
                    <SimpleInput
                      Form={Form}
                      name={"emptyCount"}
                      label="Vide"
                      customInput={
                        <Input
                          disabled
                          className={style.landing__input_number}
                        />
                      }
                    />
                  </div>
                </>
              )}
              {activeTabID === OperationConstant.BAG_ID && (
                <>
                  {" "}
                  <div className={style.landing__form_item}>
                    <SimpleInput
                      Form={Form}
                      name={"totalBagTonnage"}
                      label="Total tonnage sacherie"
                      customInput={
                        <Input
                          disabled
                          className={style.landing__input_number}
                        />
                      }
                    />
                  </div>
                  <div className={style.landing__form_item}>
                    <SimpleInput
                      Form={Form}
                      name={"remainingBagTonnage"}
                      label="Restant tonnage sacherie"
                      customInput={
                        <Input
                          disabled
                          className={style.landing__input_number}
                        />
                      }
                    />
                  </div>
                </>
              )}

              {activeTabID !== OperationConstant.CONTAINER_ID && (
                <>
                  <div className={style.landing__form_item}></div>
                </>
              )}
              {activeTabID === OperationConstant.CONTAINER_ID && (
                <div className={style.landing__form_item}>
                  <SimpleInput
                    Form={Form}
                    name={"remainingContainerCount"}
                    label="Total conteneurs restants"
                    customInput={
                      <Input disabled className={style.landing__input_number} />
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </FormProvider>

        <CustomTabs
          items={tabItems}
          tabName="mouvement"
          extraContent={
            <Popover
              content={<SelectType />}
              trigger="click"
              open={openTooltip}
              onOpenChange={(visible) => setOpenTooltip(visible)}
            >
              <Button
                className="d-flex align-items-center gap-2"
                style={{ backgroundColor: "#0560FD", color: "#ffffff" }}
              >
                <IoIosAddCircleOutline />
                Ajouter
              </Button>
            </Popover>
          }
        />
      </div>

      {isShowForm && LoadedFormComponent && (
        <Suspense fallback={<Loader isLoading />}>
          <CustomDrawer
            isOpen={isShowForm}
            onClose={onShowAddHandler}
            title={"Nouveau"}
            width={"75%"}
          >
            <LoadedFormComponent onFinish={onFinishAction} />
          </CustomDrawer>
        </Suspense>
      )}
    </>
  );
};
